// Shield with a check — the Provably Fair menu icon.
// Matches the other menu glyphs: named export, 24x24 viewBox, props spread so
// the caller sets width/height, and the same #dcdfe1 menu-icon grey.
export const ShieldSVG = (props) => (
  <svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M11.7 2.31a.75.75 0 0 1 .6 0l7 2.94a.75.75 0 0 1 .45.69v5.52c0 4.95-3.3 9.55-7.98 10.99a.75.75 0 0 1-.44 0C6.65 21 3.35 16.4 3.35 11.46V5.94a.75.75 0 0 1 .46-.69l7-2.94Zm.3 1.51L5.85 6.44v5.02c0 4.2 2.72 8.12 6.6 9.46 3.88-1.34 6.6-5.26 6.6-9.46V6.44L12 3.82Zm4.03 5.6a.75.75 0 0 1 0 1.06l-4.6 4.6a.75.75 0 0 1-1.06 0l-2.3-2.3a.75.75 0 1 1 1.06-1.06l1.77 1.77 4.07-4.07a.75.75 0 0 1 1.06 0Z"
      fill="#dcdfe1"
    />
  </svg>
)
